// Single source of truth for cities supported by SCAP delivery / vendor coverage.
// Adding a new city? Add it here once and every selector picks it up.
export const SUPPORTED_CITIES = ['Tanger', 'Rabat', 'Marrakech', 'Casablanca'];
export const DEFAULT_CITY = 'Casablanca';

export function isSupportedCity(value) {
  return SUPPORTED_CITIES.includes(value);
}
